package ru.villawonka.app.data.source

import io.ktor.client.*
import io.ktor.client.request.*
import ru.villawonka.app.data.entity.request.UserSettingsRequest
import ru.villawonka.app.data.entity.response.UserCountryResponse
import ru.villawonka.app.data.entity.response.UserSettingsResponse
import ru.villawonka.app.data.utils.parseResponse
import ru.villawonka.app.AppConfig

class UserApi(private val client: HttpClient) {

    suspend fun getCountry(): UserCountryResponse = parseResponse {
        client.get(AppConfig.apiUrl + "/user/country")
    }

    suspend fun getSettings(): UserSettingsResponse = parseResponse {
        client.get(AppConfig.apiUrl + "/user/settings")
    }

    suspend fun updateSettings(userSettingsRequest: UserSettingsRequest): Unit = parseResponse {
        client.patch(AppConfig.apiUrl + "/user/settings") { setBody(userSettingsRequest) }
    }
}